import {
  SidebarGroup,
  SidebarGroupLabel,
  SidebarMenu,
  SidebarMenuButton,
  SidebarMenuItem,
  SidebarMenuSub,
  useSidebar,
} from '@/components/ui/sidebar'
import { Skeleton } from '@/components/ui/skeleton'

const SidebarSkeleton = () => {
  const { state } = useSidebar()
  const isCollapsed = state === 'collapsed'

  if (isCollapsed) {
    return (
      <>
        <SidebarGroup>
          <SidebarMenu>
            {[1, 2, 3, 4].map((item) => (
              <SidebarMenuItem key={item}>
                <SidebarMenuButton>
                  <Skeleton className='h-4 w-4 rounded' />
                </SidebarMenuButton>
              </SidebarMenuItem>
            ))}
          </SidebarMenu>
        </SidebarGroup>
      </>
    )
  }

  return (
    <>
      <SidebarGroup>
        <SidebarGroupLabel>
          <Skeleton className='h-3 w-10' />
        </SidebarGroupLabel>
        <SidebarMenu>
          {[1, 2, 3, 4].map((item) => (
            <SidebarMenuItem key={item}>
              <SidebarMenuButton>
                <Skeleton className='h-4 w-4 rounded' />
                <Skeleton className={`h-3 ${item % 2 === 0 ? 'w-32' : 'w-28'}`} />
              </SidebarMenuButton>
            </SidebarMenuItem>
          ))}
          <SidebarMenuSub />
        </SidebarMenu>
      </SidebarGroup>
    </>
  )
}

export { SidebarSkeleton }
